import React from "react";
import Vector from "../imgs/Group.png";
import Black from "../imgs/Black.png";
import "bootstrap/dist/css/bootstrap.min.css";
import {useHistory} from 'react-router-dom'

const Welcome = () => {

  const history = useHistory()

  return (
    <div className="center-containers">
      <div className="row signup-withs m-0">
        <div className="col-12 d-flex justify-content-end p-5">
          <button className="google" onClick={() => history.push('/signup')}>Need an intro?</button>
          <button className="apple" onClick={() => history.push('/signup')}>
            <img src={Vector} className="btn-icon" alt="Vector" />
            Post a bounty
          </button>
        </div>
      </div>
      <div className="content-wrapper">
        <div>
          <h1>ZOMBIE</h1>
          <h2>Get paid to make warm intros.</h2>
          <h3>A cheet sheet that turns your network into net worth.</h3>
          <button className="white-btn" onClick={() => history.push('/home')}>
            <img src={Black} className="btn-black-icon" alt="Black" /> View
            active bounties
          </button>
          <p>Over $1,200,000 in bounties waiting to be claimed.</p>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
